import { DataType, TestTemplateComparison } from "@/graphql/codegen/graphql"

export const TEST_TEMPLATE_VALUE_COMPARISONS: TestTemplateComparison[] = [
  TestTemplateComparison.EqualTo,
  TestTemplateComparison.Maximum,
  TestTemplateComparison.Minimum,
  TestTemplateComparison.Range,
]

export const DATA_TYPE_TO_LABEL_MAP: Record<string, string> = {
  [DataType.Alphanumeric]: "Alpha",
  [DataType.Numeric]: "Numeric",
}
